import useJwt from '@/auth/jwt/useJwt'

export default async function cryptUserData(userData: object): Promise<void> {
  const criptUserData = (await useJwt.post('auth/cryptUserData', userData)).data
  localStorage.setItem('userData', criptUserData)
}
